import type { FaireProductEntity } from "../../entity_types/product";

export const p_jp668ngnf6: FaireProductEntity = {
  token: "p_jp668ngnf6",
  type: "product",
  name: "Táche Pistachio Milk Latte",
  brandToken: "b_jaxvn3rd8j",
  brandName: "Táche Pistachio Milk",
  imageUrl:
    "https://cdn.faire.com/fastly/7ba3398214d6fa7e9f80d0ad5c97337c452340980efec6595c547bba75e174c6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/870922f5f4e2f74d2fe4602d530631c36bfd22a5e4338109c46825b0be84bdec.png",
    "https://cdn.faire.com/fastly/fc5ad9dfb691af035705d0243856ee8b6ec2ea2d2e331d81cea4291c32d622e0.png",
    "https://cdn.faire.com/fastly/b25bdff825cbd09d7758000feda72cd24a0ffd28a2a6a09f538273ebbb3b0382.png",
    "https://cdn.faire.com/fastly/9cfca0eac68b7f6ab9ebb270e1198f47a35d09b1079123ba1d2ac8ada99ae928.png",
    "https://cdn.faire.com/fastly/b12e106cb946d1bf8742dc825279c2c1b08706df61155dea1eab373f9778ac6e.png",
  ],
  priceDollars: 2.8,
  description:
    "The first ever ready-to-drink Pistachio Milk Latte. A delicious, dairy-free latte made with 100% freshly brewed cold brew and lightly sweet & creamy pistachio milk. The Táche Pistachio Milk Latte is your go-anywhere, do-anything sip savior.\n\n• Better tasting: A little bit nutty and a little bit sweet with a velvety mouthfeel. Perfect in lattes, hot chocolate, and more.\n\n• Better for the planet: Pistachio trees require 75% less water than almonds.\n\n• Better for you: Unlike oat milk, Táche has no added rapeseed or canola oil.\n\n• Ready to enjoy: Táche is shelf stable with a shelf life of up to one year. Our lattes ship in cases of 12 x 11oz cartons. Pro tip: order in multiples of two cases for most efficient shipping.\n\n• On the go: Treat your guests to great taste on the go. Táche lattes are lightly sweetened and built for portability and are handbag ready.",
  tags: [],
  msrpDollars: 5.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:11.915Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
